import React, { useState, useEffect } from 'react';
import logo from '../images/logo.png';
import style from '../css/NavBar.module.css';
import { Link } from 'react-router-dom';
import {
	FaCircle,
	FaHome,
	FaInfo,
	FaPhone,
	FaRegFileAlt,
	FaShieldAlt,
	FaTeamspeak,
	FaThumbsUp,
	FaUser,
} from 'react-icons/fa';
import { FaBars, FaScrewdriverWrench, FaX } from 'react-icons/fa6';
import { FaMapMarkerAlt } from 'react-icons/fa';
import useLocation from '../components/useLocation';

function Navbar() {
	const [show, setShow] = useState(false);

	useEffect(() => {
		if (show) {
			document.body.style.overflow = 'hidden';
			window.scrollTo(0, 0);
		} else {
			document.body.style.overflow = 'auto';
		}

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [show]);

	const clearLocation = () => {
		// Remove the location from localStorage
		localStorage.removeItem('location');

		window.location.reload(); // Reload the page to reflect the change
	};

	const location = useLocation();

	return (
		<div>
			<div className={style.container}>
				<img src={logo} alt="" className={style.logo} />
				<div className={style.btn_box} style={{ padding: 15 }}>
					<Link className={style.btn} to={'/'}>
						{/* <FaHome size={15} color="white" /> */}
						Home
					</Link>

					<FaCircle size={5} color="black" />

					<Link className={style.btn} to={'/service'}>
						{/* <FaScrewdriverWrench size={15} color="white" /> */}
						Services
					</Link>
					<FaCircle size={5} color="black" />
					<Link className={style.btn} to={'/about-us'}>
						{/* <FaInfo size={15} color="white" /> */}
						About Us
					</Link>
					<FaCircle size={5} color="black" />
					<Link className={style.btn} to={'/contact-us'}>
						{/* <FaTeamspeak size={15} color="white" /> */}
						Contact Us
					</Link>
					<FaCircle size={5} color="black" />
					<Link
						className={style.btn}
						to={'https://customer.hometech-repairs.in/'}
						style={{ color: 'darkcyan' }}
					>
						{/* <FaUser size={15} color="white" /> */}
						Login
					</Link>
				</div>

				<div className={style.btn_box}>
					<div
						style={{ cursor: 'pointer' }}
						onClick={clearLocation}
						className={style.location}
					>
						<FaMapMarkerAlt color="black" size={20} />
						<div style={{ color: 'black' }}>
							<p>{location}</p>
							<p style={{ fontSize: 12 }}>Change Location</p>
						</div>
					</div>

					<p style={{ color: 'black' }}>|</p>

					<Link to="tel:+919036874408" className={style.text_rows}>
						{/* <p>9036874408</p> */}
						<FaPhone size={20} />
					</Link>
				</div>
			</div>

			<div className={style.mob_container}>
				<img src={logo} alt="" className={style.logo} />
				<div onClick={() => setShow(!show)}>
					<FaBars size={20} color="white" />
				</div>
			</div>

			{show && (
				<div className={style.mob_div}>
					<div onClick={() => setShow(false)} className={style.btn_close}>
						<FaX size={20} color="black" />
					</div>

					<Link
						className={style.btn_mob}
						to={'https://customer.hometech-repairs.in/'}
					>
						<FaUser size={15} color="black" /> Login
					</Link>

					<div onClick={clearLocation} className={style.btn_mob}>
						<FaMapMarkerAlt color="black" size={20} />
						<div style={{ color: 'black' }}>
							<p>{location}</p>
							<p style={{ fontSize: 12 }}>Change Location</p>
						</div>
					</div>

					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/'}
					>
						<FaHome size={15} color="black" />
						Home
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/service'}
					>
						<FaScrewdriverWrench size={15} color="black" />
						Services
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/about-us'}
					>
						<FaInfo size={15} color="black" />
						About Us
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/contact-us'}
					>
						<FaTeamspeak size={15} color="black" />
						Contact Us
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/privacy-policy'}
					>
						<FaShieldAlt size={15} color="black" />
						Privacy & Policy
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/terms-and-conditions'}
					>
						<FaRegFileAlt size={15} color="black" />
						Terms & Conditions
					</Link>
					<Link
						className={style.btn_mob}
						onClick={() => setShow(false)}
						to={'/feedback'}
					>
						<FaThumbsUp size={15} color="black" />
						Feed-Back
					</Link>
					<Link to={'tel:+919036874408'} className={style.btn_mob}>
						<FaPhone color="black" size={20} />
						<p>+91 9036874408</p>
					</Link>
				</div>
			)}
		</div>
	);
}

export default Navbar;
